import type { BlockMultipleChoice } from 'shared-types';

type LocaleData = BlockMultipleChoice['locales'][string];

const defaultBlockData = {
  feedbackType: 'default' as const,
  isMandatory: false,
  isSingleChoice: true as const,
  pointsWeight: 2,
  requireAnswerToProceed: false,
  useResultBasedFeedback: false
};

const translatable: LocaleData['translatable'] = {
  feedback: '',
  feedbackCorrect: '',
  feedbackIncorrect: '',
  option_1_text: '',
  option_1_feedback: '',
  question: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  feedback: '{{ locales.translatable.feedback }}' as const,
  feedbackCorrect: '{{ locales.translatable.feedbackCorrect }}' as const,
  feedbackIncorrect: '{{ locales.translatable.feedbackIncorrect }}' as const,
  options: [
    {
      correct: false,
      feedback: '{{ locales.translatable.option_1_feedback }}' as const,
      text: '{{ locales.translatable.option_1_text }}' as const
    }
  ],
  question: '{{ locales.translatable.question }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockSingleChoiceData: Extract<
  BlockMultipleChoice,
  { isSingleChoice: true }
> = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockMultipleChoice['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
